import { useState } from "react";
import { Nav, Hero, MarqueeStrip, IncludesSection, ServicesSection, Footer } from "@/components/landing/sections";
import BookingSection from "@/components/landing/BookingSection";

export default function Landing() {
  const [selectedService, setSelectedService] = useState("");

  const selectService = (title) => {
    setSelectedService(title);
    document.getElementById("agendar")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <main className="relative overflow-x-hidden" style={{ background: "var(--bg)" }}>
      <Nav />
      <Hero />
      <MarqueeStrip />
      <IncludesSection />
      <ServicesSection selected={selectedService} onSelect={selectService} />
      <BookingSection selectedService={selectedService} onServiceChange={setSelectedService} />
      <Footer />
    </main>
  );
}
